// extracted by mini-css-extract-plugin
export default {"routeName":"BusAutoCompleteResult_routeName__BHKln"};